import Vue from 'vue'

const tinycolor = require('tinycolor2')

Vue.prototype.$color = tinycolor
